import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SendIcon from '@mui/icons-material/Send';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter subscription
    console.log('Newsletter subscription');
  };

  return (
    <footer className="footer">
      {/* Newsletter Section */}
      {/* <div className="footer__newsletter">
        <div className="footer__newsletter-container">
          <motion.div 
            className="footer__newsletter-content"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="footer__newsletter-title">
              <SendIcon className="footer__newsletter-icon" />
              Subscribe to Our Newsletter
            </h3>
            <p className="footer__newsletter-text">
              Get the latest movie updates, exclusive content, and special offers delivered to your inbox
            </p>
            <form className="footer__newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="footer__newsletter-input"
                required
              />
              <button type="submit" className="footer__newsletter-button">
                Subscribe
              </button>
            </form>
          </motion.div>
        </div>
      </div> */}

      {/* Main Footer Content */}
      <div className="footer__main">
        <div className="footer__container">
          <div className="footer__grid">
            {/* Brand Column */}
            <motion.div 
              className="footer__column footer__column--brand"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <Link to="/" className="footer__logo">
                <PlayCircleOutlineIcon className="footer__logo-icon" />
                <span className="footer__logo-text">
                  NEXTAPE<span className="footer__logo-accent">STUDIOS</span>
                </span>
              </Link>
              <p className="footer__brand-description">
                Your ultimate destination for movies and TV series. Discover, watch, and explore 
                thousands of titles from all genres.
              </p>
              <div className="footer__social">
                <a href="#" className="footer__social-link" aria-label="Facebook">
                  <FacebookIcon />
                </a>
                <a href="#" className="footer__social-link" aria-label="Twitter">
                  <TwitterIcon />
                </a>
                <a href="#" className="footer__social-link" aria-label="Instagram">
                  <InstagramIcon />
                </a>
                <a href="#" className="footer__social-link" aria-label="YouTube">
                  <YouTubeIcon />
                </a>
                <a href="#" className="footer__social-link" aria-label="LinkedIn">
                  <LinkedInIcon />
                </a>
              </div>
            </motion.div>

            {/* Quick Links */}
            <motion.div 
              className="footer__column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <h4 className="footer__column-title">Quick Links</h4>
              <ul className="footer__links">
                <li><Link to="/" className="footer__link">Home</Link></li>
                <li><Link to="/movies" className="footer__link">Movies</Link></li>
                <li><Link to="/tv-series" className="footer__link">TV Series</Link></li>
                <li><Link to="/trending" className="footer__link">Trending</Link></li>
                <li><Link to="/new" className="footer__link">New Releases</Link></li>
                <li><Link to="/popular" className="footer__link">Most Popular</Link></li>
              </ul>
            </motion.div>

            {/* Categories */}
            <motion.div 
              className="footer__column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h4 className="footer__column-title">Categories</h4>
              <ul className="footer__links">
                <li><Link to="/genre/action" className="footer__link">Action</Link></li>
                <li><Link to="/genre/comedy" className="footer__link">Comedy</Link></li>
                <li><Link to="/genre/drama" className="footer__link">Drama</Link></li>
                <li><Link to="/genre/horror" className="footer__link">Horror</Link></li>
                <li><Link to="/genre/sci-fi" className="footer__link">Sci-Fi</Link></li>
                <li><Link to="/genre/thriller" className="footer__link">Thriller</Link></li>
              </ul>
            </motion.div>

            {/* Support */}
            <motion.div 
              className="footer__column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h4 className="footer__column-title">Support</h4>
              <ul className="footer__links">
                <li><Link to="/help" className="footer__link">Help Center</Link></li>
                <li><Link to="/faq" className="footer__link">FAQ</Link></li>
                <li><Link to="/contact" className="footer__link">Contact Us</Link></li>
                <li><Link to="/terms" className="footer__link">Terms of Service</Link></li>
                <li><Link to="/privacy" className="footer__link">Privacy Policy</Link></li>
                <li><Link to="/dmca" className="footer__link">DMCA</Link></li>
              </ul>
            </motion.div>

            {/* Contact Info */}
            <motion.div 
              className="footer__column"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h4 className="footer__column-title">Contact Info</h4>
              <div className="footer__contact">
                <div className="footer__contact-item">
                  <EmailIcon className="footer__contact-icon" />
                  <a href="mailto:support@moviedb.com" className="footer__contact-text">
                    support@nextapestudios.com
                  </a>
                </div>
                <div className="footer__contact-item">
                  <PhoneIcon className="footer__contact-icon" />
                  <a href="tel:+1234567890" className="footer__contact-text">
                    +234 111 0000 111
                  </a>
                </div>
                <div className="footer__contact-item">
                  <LocationOnIcon className="footer__contact-icon" />
                  <span className="footer__contact-text">
                    123 Movie Street,<br />
                    Abuja, Nigeria
                  </span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* App Download Section */}
          {/* <div className="footer__apps">
            <h4 className="footer__apps-title">Download Our App</h4>
            <div className="footer__apps-buttons">
              <a href="#" className="footer__app-button">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                  alt="Get it on Google Play"
                  className="footer__app-image"
                />
              </a>
              <a href="#" className="footer__app-button">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" 
                  alt="Download on the App Store"
                  className="footer__app-image"
                />
              </a>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer__bottom">
        <div className="footer__bottom-container">
          <p className="footer__copyright">
            © {currentYear} MovieDB. All rights reserved.
          </p>
          <div className="footer__bottom-links">
            <Link to="/sitemap" className="footer__bottom-link">Sitemap</Link>
            <span className="footer__separator">|</span>
            <Link to="/cookies" className="footer__bottom-link">Cookie Policy</Link>
            <span className="footer__separator">|</span>
            <Link to="/accessibility" className="footer__bottom-link">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;